import React from "react";
import ReactDOM from "react-dom/client";
import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from "./App";
import * as serviceWorker from "./serverWorker";
import reportWebVitals from "./reportWebVitals";
import {initializeApp} from 'firebase/app'
import 'firebase/database';
export const API_URL =  "https://api.test.frontforcecrm.com"
const firebaseConfig = {
  apiKey: "AIzaSyDVSUFBgG1iTUnwZ7JBus6zIovNMR6A1NY",
  authDomain: "r-wire.firebaseapp.com",
  databaseURL: "https://r-wire-default-rtdb.firebaseio.com",
  projectId: "r-wire",
  storageBucket: "r-wire.firebasestorage.app",
  messagingSenderId: "614864444194",
  appId: "1:614864444194:web:9685f606d62ca5af47a37b",
  measurementId: "G-P0FYR359R5"
};
const firebase = initializeApp(firebaseConfig);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>
);

serviceWorker.unregister()
reportWebVitals();
